import React from "react";
import { Link } from "react-router-dom";
import iconCalendar from "../../../images/icon/calendar-icon.svg";
import iconUserGradient from "../../../images/icon/user-gradient-icon.svg";


const ItemDetailsContent: React.FC = () => {
  return (
    <div className="item_details_content pb-80">
      <ul className="post_meta ul_li list-unstyled mb-25">
        {/* <li>
          <Link to="/blog-details">
            <span className="meta_label1">#ai tools tips</span>
          </Link>
        </li> */}

        <li>
          <Link to="/blog-details">
            <span className="meta_icon">
              <img src={iconCalendar} alt="Calendar" />
            </span>
            <span className="meta_label">Last Update: 02/12/2025</span>
          </Link>
        </li>
      </ul>

      <h2 className="details-content-title mb-15">
        Machine Learning Solutions: Intelligence That Learns and Adapts
      </h2>

      <p className="mb-35">
        In today’s competitive business environment, static systems and rule-based processes can no longer keep up with evolving markets and customer needs. Machine learning (ML) provides adaptive intelligence analyzing data, recognizing patterns, and continuously improving decisions over time.
      </p>

      {/* AUTHOR / META INFO */}
      <div className="post-meta-wrap">
        <div className="row mt-none-15">
          {/* LEFT SIDE */}
          <div className="col-md-6 mt-15">
            <ul className="post_meta list-unstyled ul_li">
              <li>
                <Link to="/">
                  <span className="meta_icon">
                    <img src={iconUserGradient} alt="User" />
                  </span>
                  <span className="meta_label">by BrainMachine.AI</span>
                </Link>
              </li>

              {/* <li>
              
                  <span className="meta_icon">
                    <img src={iconComment} alt="Comments" />
                  </span>
                  <span className="meta_label">6 Comments</span>
              </li> */}

              {/* <li>
                
                  <span className="meta_icon">
                    <img src={iconEye} alt="Views" />
                  </span>
                  <span className="meta_label">32 Views</span>
              </li> */}
            </ul>
          </div>

          {/* RIGHT SIDE */}
          {/* <div className="col-md-6 mt-15">
            <ul className="post_meta list-unstyled ul_li justify-content-md-end">
              <li>
                
                  <span className="meta_icon">
                    <img src={iconLink} alt="Copy Link" />
                  </span>
                  <span className="meta_label">Copy Link</span>
               
              </li>

              <li>
                
                  <span className="meta_icon">
                    <img src={iconBookmark} alt="Bookmark" />
                  </span>
                  <span className="meta_label">Bookmark</span>
               
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ItemDetailsContent;
